export const load = () => ({
	title: 'Most Effective Soundproofing Materials',
	showTitle: true,
});
